<script setup lang="ts">
withDefaults(defineProps<{ size?: number }>(), { size: 20 })
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="currentColor"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.032 3.5A1.532 1.532 0 1 1 3.5 5.032 1.534 1.534 0 0 1 5.032 3.5ZM3.75 7.25H6.3v9H3.75v-9Zm4.1 0h2.44v1.23h.034c.34-.644 1.17-1.323 2.408-1.323 2.576 0 3.052 1.694 3.052 3.895V16.25h-2.55v-4.664c0-.952-.016-2.177-1.326-2.177-1.328 0-1.531 1.037-1.531 2.107v4.734H7.85v-9Z" />
  </svg>
</template>
